import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div id="main">
      <p>このページは存在しません。</p>
      <p>
        <Link to="/ja/login">ログイン画面へ</Link>
      </p>
      <p>This page dose not exist.</p>
      <p>
        <Link to="/en/login">Link to Login Page</Link>
      </p>
    </div>
  );
}

export default NotFoundPage;
